import { MAX_CHALLENGES } from 'utils/wordle.utils';
import { unicodeSplit, getGuessStatuses } from 'utils/wordle.utils';
import { Cell } from './Cell';

type CurrentRowProps = {
    solution: string;
    guess: string;
    className: string;
};

type GridProps = {
    solution: string;
    guesses: string[];
    currentGuess: string;
    isRevealing?: boolean;
    currentRowClassName: string;
};

type CompleteRowProps = {
    solution: string;
    guess: string;
    isRevealing?: boolean;
};

const CompletedRow = ({ solution, guess, isRevealing }: CompleteRowProps) => {
    const statuses = getGuessStatuses(solution, guess);
    const splitGuess = unicodeSplit(guess);

    return (
        <div className="flex justify-center mb-1">
            {splitGuess.map((letter, i) => (
                <Cell key={i} value={letter} status={statuses[i]} position={i} isRevealing={isRevealing} isCompleted />
            ))}
        </div>
    );
};

const CurrentRow = ({ solution, guess, className }: CurrentRowProps) => {
    const splitGuess = unicodeSplit(guess);
    const emptyCells = Array.from(Array(solution.length - splitGuess.length));
    const classes = `flex justify-center mb-1 ${className}`;

    return (
        <div className={classes}>
            {splitGuess.map((letter, i) => (
                <Cell key={i} value={letter} />
            ))}
            {emptyCells.map((_, i) => (
                <Cell key={i} />
            ))}
        </div>
    );
};

const EmptyRow = ({ solution }) => {
    const emptyCells = Array.from(Array(solution.length));

    return (
        <div className="flex justify-center mb-1">
            {emptyCells.map((_, i) => (
                <Cell key={i} />
            ))}
        </div>
    );
};

export const Grid = ({ solution, guesses, currentGuess, isRevealing, currentRowClassName }: GridProps) => {
    const empties = guesses.length < MAX_CHALLENGES - 1 ? Array.from(Array(MAX_CHALLENGES - 1 - guesses.length)) : [];

    return (
        <>
            {guesses.map((guess, i) => (
                <CompletedRow
                    key={i}
                    solution={solution}
                    guess={guess}
                    isRevealing={isRevealing && guesses.length - 1 === i}
                />
            ))}
            {guesses.length < MAX_CHALLENGES && (
                <CurrentRow solution={solution} guess={currentGuess} className={currentRowClassName} />
            )}
            {empties.map((_, i) => (
                <EmptyRow solution={solution} key={i} />
            ))}
        </>
    );
};
